import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Marquee from '../components/Marquee';
import Header from '../components/Header';
import Hero from '../components/Hero';
import WhatWeDo from '../components/WhatWeDo';
import WhyItMatters from '../components/WhyItMatters';
import ESGAsCode from '../components/ESGAsCode';
import Workflow from '../components/Workflow';
import Industries from '../components/Industries';
import Engagement from '../components/Engagement';
import Trust from '../components/Trust';
import Contact from '../components/Contact';
import Partners from '../components/Partners';
import Compliance from '../components/Compliance';
import Footer from '../components/Footer';

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Small delay to allow page to render before scrolling
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <main className="min-h-screen bg-[#FAFAF5]">
      <Marquee />
      <Header />
      <Hero />
      <WhatWeDo />
      <WhyItMatters />
      <ESGAsCode />
      <Workflow />
      <Industries />
      <Engagement />
      <Trust />
      <Contact />
      <Partners />
      <Compliance />
      <Footer />
    </main>
  );
}
